import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import qs from 'qs';

import AnalyticsBase from '../AnalyticsBase';
import AnalyticsFilterBar from '../AnalyticsFilterBar';
import BreadcrumbNav from '../../nav/BreadcrumbNav';

import { initializeAnalytics } from '../../../state/reducer/analytics/actionCreators/initializeAnalytics';
import { ParamUrlBuilder } from '../../../lib/ParamUrlBuilder';
import * as DateUtils from '../../../lib/dateUtils';
import * as LibraryState from '../../../state/reducer/library/library';
import * as AnalyticsState from '../../../state/reducer/analytics/analytics';

import Console from '../../../lib/debug';

const PAGE_KEY = 'readiness-survey-team';

class ReadinessSurveyTeamView extends Component {
    constructor(props) {
        super(props);
        LibraryState.fetchTeams();
    }

    componentDidUpdate(prevProps, prevState) {
        this.loadAnalytics();
    }

    loadAnalytics = () => {
        const dataParams = this.getDataParams();
        this.props.dispatch(initializeAnalytics(PAGE_KEY, dataParams));
    };

    setSearchParams = params => {
        const existingParams = AnalyticsState.getSearchParams();
        AnalyticsState.updateSearchParams({
            ...existingParams,
            ...params
        });
    };

    getDataParams = () => {
        const searchParams = AnalyticsState.getSearchParams();

        let date = searchParams.date;
        if (!DateUtils.isValidDateString(date)) {
            date = moment();
            date = moment(date, DateUtils.CALENDAR_FORMAT);
        }

        let teamIds = parseInt(searchParams.team_ids, 10);
        if (!teamIds || typeof teamIds !== 'number') {
            teamIds = [];
        } else {
            teamIds = [teamIds];
        }

        return {
            team_ids: teamIds,
            date: moment(date).format('YYYY-MM-DD')
        };
    };

    getSelectedId = () => {
        const params = this.getDataParams();
        if (params.team_ids.length === 1) {
            return params.team_ids[0];
        }

        return undefined;
    };

    getDate = () => {
        const dataParams = this.getDataParams();
        return moment(dataParams.date);
    };

    handleDateChange = date => {
        this.setSearchParams({
            date: date.format(DateUtils.CALENDAR_FORMAT)
        });
    };

    onSelectTeam = (ev, { suggestion }) => {
        const team_ids = suggestion.allOption === true ? [] : [suggestion.id];

        this.setSearchParams({
            team_ids: team_ids
        });
    };

    onClick = (e, row, rowIndex) => {
        const dataParams = this.getDataParams();
        const paramUrlBuilder = new ParamUrlBuilder(
            '/analytics/readiness-survey-athlete/'
        );

        paramUrlBuilder.setUserId(row.user_id);

        if (moment().diff(this.getDate(), 'days') !== 0) {
            paramUrlBuilder.setEndDate(this.getDate());
        }

        AnalyticsState.navigate(paramUrlBuilder.buildUrl());
    };

    getPageTitle = () => {
        let title =
            this.props.metaTree &&
            this.props.metaTree.instances &&
            this.props.metaTree.instances[PAGE_KEY] &&
            this.props.metaTree.instances[PAGE_KEY].title;
        if (title) {
            return title;
        }
        return 'Team Readiness';
    };

    render() {
        Console.render('ReadinessSurveyTeamView');
        const rowEvents = {
            onClick: this.onClick
        };

        const crumbs = [
            {
                displayString: 'Analytics',
                link: `/analytics`,
                editable: false
            },
            {
                displayString: this.getPageTitle(),
                link: null,
                editable: false
            }
        ];

        const dataParams = this.getDataParams();

        return (
            <div className="has-filter-bar">
                <BreadcrumbNav crumbs={crumbs} />
                <AnalyticsFilterBar
                    datePicker={{
                        date: this.getDate(),
                        onChange: this.handleDateChange
                    }}
                    teamSelector={{
                        selectedId: this.getSelectedId(),
                        onSelect: this.onSelectTeam,
                        allOptionText: 'All Athletes'
                    }}
                />
                <AnalyticsBase rowEvents={rowEvents} />;
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        teams: state.library.teamsTree,
        metaTree: state.analytics.metaTree
    };
};

export default connect(mapStateToProps)(ReadinessSurveyTeamView);
